import React, { useEffect, useState } from 'react'
import { Input } from '@ow/comps'

const EditableCell = function ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData,
}) {
  const [value, setValue] = useState(initialValue)

  const onChange = (e) => {
    setValue(e.target.value)
  }

  const onBlur = () => {
    updateMyData(index, id, value)
  }

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <Input
      className="w-4/5 border-0"
      key={id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}

export default EditableCell
